import constants from './constants';

export const clearTokenOnInit = (config) => {
	if (config.clearTokenOnInit) {
		window.sessionStorage.removeItem(constants.BEARER_TOKEN);
		window.sessionStorage.removeItem(constants.AUTHENTICATED_2FA_TOKEN);
	}
};
